import React from 'react';

// Material-UI
import {
  DataGrid,
  GridColDef,
  GridOverlay
} from '@mui/x-data-grid';

// Styles
import { useTheme } from '@mui/material/styles';

import {
  RequestNote
} from '../../models';

interface NotesGridProps {
  isLoading: boolean;
  rows: Array<RequestNote>;
}

const NotesGrid: React.FC<NotesGridProps> = (props) => {

  // #region Styles

  const theme = useTheme();
  const styles = {
    root: {
      '& .super-app-theme--header': {
        backgroundColor: 'rgba(255, 7, 0, 0.55)'
      }
    },
    noRows: {
      margin: theme.spacing(2, 0, 0, 0),
      padding: theme.spacing(2, 0, 2, 0)
    }
  };

  // #endregion

  // #region Methods

  /*
 * Grid column definitions
 */
  const columns = (): Array<GridColDef> => {
    return [
      {
        field: 'createdBy',
        headerName: 'Member/Guest',
        width: 175,
        type: 'string',
      }, {
        field: 'referenceNumber',
        headerName: 'Ref #',
        width: 85,
        type: 'string',
      }, {
        field: 'minArrivalDate',
        headerName: 'Arrival',
        width: 125,
        type: 'string',
      }, {
        field: 'maxDepartureDate',
        headerName: 'Departure',
        width: 125,
        type: 'string',
      }, {
        field: 'groupSize',
        headerName: 'Group Size',
        width: 85,
        type: 'number',
      }, {
        field: 'nights',
        headerName: 'Nights',
        width: 85,
        type: 'number',
      }, {
        field: 'updated',
        headerName: 'Updated',
        width: 100,
        type: 'string',
      }, {
        field: 'notes',
        headerName: 'Notes',
        minWidth: 250,
        type: 'string',
        flex: 1
      }
    ];
  }

  /*
   * Overlay displayed when no data
   */
  const noRowsOverlay = () => {
    return (
      <GridOverlay>
        <div style={styles.noRows}>No request notes for the selected date range</div>
      </GridOverlay>
    );
  }

  // #endregion

  return (
    <DataGrid
      columns={columns()}
      slots={{
        noRowsOverlay: noRowsOverlay
      }}
      rows={props.rows}
      getRowId={(row) => row.signupID} // Special unique ID for each row
      sx={styles.root}
      density="compact"
      disableColumnSelector
      disableRowSelectionOnClick
      hideFooter
      loading={props.isLoading}
    />
  );

}

export default NotesGrid;